const Strings = {
  INFORMATION: {
    SE: 'Information',
    EN: 'Information'
  },
  INFORMATION_FROM_YOUR_BOARD: {
    SE:
      'Här hittar du kontaktuppgifter och annan matnyttig information från din styrelse.',
    EN: 'Here you find information from your association.'
  },
  INFO_BOARD: {
    SE: 'Infotavlan',
    EN: 'Info board'
  },
  NO_INFORMATION: {
    SE: 'Det ingen information att tillgå.',
    EN: 'There are no information.'
  },
  NO_INFORMATION_ADMIN: {
    SE:
      'Ingen information har skapats, tryck på "förenings inställningar" för att lägga till information.',
    EN:
      'No information has been created, press "association settings" to add information.'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/pages/communityInformation/CommunityInformation/strings.js